module.exports = __webpack_public_path__ + "img/2.32877bc7.svg";